import React from 'react'
import Link from "next/link";
import styled from "styled-components";
import RadiusGenerate from "@helpers/radius.generate";
import Icon from "./icon";
import {isEmpty} from "../helpers/helpers";

function HotLinks({className, items, icon}) {

    return (
        <Container className={"d-md-flex flex-wrap" + ((typeof className !== "undefined") ? className : '')}>
            {
                items.map((hotLink, key) =>
                    <Link href="/properties" as={hotLink.href} key={hotLink.id ?? key}>
                        <a key={hotLink.id ?? key}>
                            <Item className="d-flex align-items-center mb-0 mb-md-8">
                                {(!isEmpty(icon)) ? <Icon className="ml-24 ml-lg-16"> {icon}</Icon> : ''}
                                <span>{hotLink.title}</span>
                            </Item>
                        </a>
                    </Link>
                )
            }
        </Container>
    )
}

export default HotLinks;

// styles
const Item = styled.div`
    background-color: ${props => props.theme.info};
    padding: 8px 16px 8px 24px;
    ${RadiusGenerate('8px')};
    
    @media (max-width: ${props => props.theme.screenXsMax}) {
        padding: 12px 0;
    }
    
    @media (min-width: ${props => props.theme.screenXsMax}) {
        &:hover {
            background-color: ${props => props.theme.infoHover};
        }
    }
    
    .icons {
        width: 16px;
        max-width: 16px;
    }
`;

const Container = styled.div`
    ${RadiusGenerate('8px')};
    
    @media (max-width: ${props => props.theme.screenXsMax}) {
        background-color: ${props => props.theme.info};
        padding: 8px 24px;
        
        ${Item} {
            ${RadiusGenerate('0px')};
            border-bottom: 1px solid ${props => props.theme.white};
        }
        
        & a:last-child ${Item} {
            border-bottom: 0;
        }
    }
    
    @media (min-width: ${props => props.theme.screenXsMax}) {
       a {
            margin-left: 8px;
         }
    }
`;